export const BABEL7_VERSION = '7.21.8';
